"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const userSettings_interface_1 = require("./userSettings.interface");
class User {
    constructor(data) {
        this.setGlobalSettings = (globalCurrency, showExpenseNumbers, enableOcr, enableOcrItemization, showGrossAmount, csvDelimiter, language, enableGoToNextExpense, csvNumberDecimalSeparator) => {
            this.settings.globalCurrency = globalCurrency;
            this.settings.showExpenseNumbers = showExpenseNumbers;
            this.settings.enableOcr = enableOcr;
            this.settings.enableOcrItemization = enableOcrItemization;
            this.settings.showGrossAmount = showGrossAmount;
            this.settings.csvDelimiter = csvDelimiter;
            this.settings.language = language;
            this.settings.enableGoToNextExpense = enableGoToNextExpense;
            this.settings.csvNumberDecimalSeparator = csvNumberDecimalSeparator !== null && csvNumberDecimalSeparator !== void 0 ? csvNumberDecimalSeparator : userSettings_interface_1.CsvNumberDecimalSeparatorTypeEnum.COMMA;
        };
        this.getUserLanguage = () => this.settings.language;
        this.getSecurityOptions = () => this.settings && this.settings.security;
        this.setSecurityKeyValue = (key, value) => {
            if (this.settings && this.settings.security) {
                if (Object.keys(this.settings.security).includes(key)) {
                    this.settings.security = Object.assign(Object.assign({}, this.settings.security), { [key]: value });
                }
            }
        };
        this.getNotificationSettings = () => this.settings && this.settings.notifications;
        this.setNotificationSettings = (key, value) => {
            if (this.settings && this.settings.notifications) {
                if (Object.keys(this.settings.notifications).includes(key)) {
                    this.settings.notifications = Object.assign(Object.assign({}, this.settings.notifications), { [key]: value });
                }
            }
        };
        // retrieve user company profile by companyId
        this.getUserCompanyProfile = (companyId) => { var _a, _b; return (_b = (_a = this.companyProfiles) === null || _a === void 0 ? void 0 : _a.filter((userProfile) => { var _a; return ((_a = userProfile.companyId) === null || _a === void 0 ? void 0 : _a.toString()) === (companyId === null || companyId === void 0 ? void 0 : companyId.toString()); })) === null || _b === void 0 ? void 0 : _b[0]; };
        // update user company profile from input by company id
        this.updateUserCompanyProfile = (input, companyId) => {
            var _a;
            return (_a = this.companyProfiles) === null || _a === void 0 ? void 0 : _a.map((profile) => {
                if (profile.companyId === companyId) {
                    return Object.assign(Object.assign({}, profile), { roleId: input.roleId, superior: input.superior, team: input.team, approvals: input.approvals });
                }
                return profile;
            });
        };
        if (data) {
            this.deserialize(data);
        }
    }
    static newFromAccessToken(accessToken) {
        return new User(accessToken);
    }
    getInitials() {
        var _a, _b;
        const fullName = this.name.split(" ");
        return `${fullName[0].charAt(0)} ${(_b = (_a = fullName[1]) === null || _a === void 0 ? void 0 : _a.charAt(0)) !== null && _b !== void 0 ? _b : ""}`;
    }
    isEnrolledInCardProgramOfCompany({ companyId }) {
        var _a, _b;
        return !!((_b = (_a = this.getUserCompanyProfile(companyId)) === null || _a === void 0 ? void 0 : _a.weavrData) === null || _b === void 0 ? void 0 : _b.userId);
    }
    deserialize(input) {
        var _a, _b;
        Object.assign(this, input);
        this.id = input.id || input._id;
        if (!this.name) {
            this.name = !input.firstName && !input.lastName ? "" : `${(_a = input.firstName) !== null && _a !== void 0 ? _a : ""} ${(_b = input.lastName) !== null && _b !== void 0 ? _b : ""}`.trim();
        }
        return this;
    }
}
exports.User = User;
